export const supportQualityReasonTags = [
  "jakosc",
  "konsystencja",
  "aplikacja",
  "grudki",
  "wtracenia",
  "pekanie",
  "bardzo-miekkie-podczas-szlifowania",
  "bardzo-twarde-podczas-szlifowania",
  "jakosc-inne",
] as const;

export type SupportQualityReasonTag = (typeof supportQualityReasonTags)[number];

const qualityReasonTagSet = new Set<string>(supportQualityReasonTags);

function isSupportQualityReasonTag(tag: string): boolean {
  return qualityReasonTagSet.has(tag.trim().toLowerCase());
}

export function hasSupportQualityReason(tags: readonly string[] | undefined): boolean {
  return (tags ?? []).some(isSupportQualityReasonTag);
}
